import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'mstar-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent {
  @Input() noMarginTop = false;
  @Input() headerText = '';
  @Input() icon = '';
  @Input() noHeader = false;
  @Input() displayStyle = 'block';
}
